var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOverview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-24 -344)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 48,
    height: 48,
    transform: "translate(24 344)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(40 358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M16.062,20H.938a.925.925,0,0,1-.666-.3A1.025,1.025,0,0,1,0,18.993V6L5.667,0,16.054,0A.983.983,0,0,1,17,.992V19.008A.968.968,0,0,1,16.062,20ZM1.889,8V18H15.111V2H7.556V7a.974.974,0,0,1-.944,1ZM5.667,2.83,2.672,6H5.667Z",
    fill: "#767493"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverview);
export default __webpack_public_path__ + "static/media/icon_overview.45b5115a994ce54dc74f7806b878d7f0.svg";
export { ForwardRef as ReactComponent };